import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";

interface GeneralInfoSectionProps {
    processTime: Date | null;
    onProcessTimeChange: (val: Date | null) => void;
    createdUser: string;
}

export const GeneralInfoSection = ({ processTime, onProcessTimeChange, createdUser }: GeneralInfoSectionProps) => {
    const { t } = useTranslate();

    return (
        <>
            {/* DateTime - PROCESS_TIME */}
            <Grid container alignItems="center" justifyContent="flex-start">
                <Grid
                    md={6}
                    xs={6}
                    sx={{
                        borderBottom: '1px solid #E0E0E0',
                        minHeight: "45px",
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                        {t("datetime")}
                    </ByzMuiTypography>
                </Grid>
                <Grid
                    md={2.4}
                    xs={2.4}
                    sx={{

                        minHeight: "45px",
                        marginLeft: "10px",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <ByzMuiDateTimePicker
                        sx={{ width: "300px !important", marginLeft: "10px" }}
                        value={processTime}
                        onChange={onProcessTimeChange}
                    />
                </Grid>
            </Grid>

            {/* Created By - CUSER */}
            <Grid container alignItems={'center'} justifyContent={'flex-start'}>
                <Grid
                    md={6}
                    xs={6}
                    sx={{
                        borderBottom: '1px solid #E0E0E0',
                        minHeight: "45px",
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                        {t("createdby")}
                    </ByzMuiTypography>
                </Grid>
                <Grid
                    md={6}
                    xs={6}
                    sx={{
                        minHeight: "45px",
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <ByzMuiTextField
                        sx={{ width: "300px !important", marginLeft: "10px" }}
                        color='info'
                        disabled
                        value={createdUser || ''}
                        label={t("createdby")}
                        variant="outlined"
                    />
                </Grid>
            </Grid>
        </>
    );
};
